if (!global._babelPolyfill) {
  require('babel-polyfill');
}

import Vue from 'vue';
import VueI18n from 'vue-i18n';
import VeeValidate from 'vee-validate';
import VueLogger from 'vuejs-logger';
import VueResource from 'vue-resource';
import VueCookies from 'vue-cookies';
import * as Vuex from 'vuex';

import $ from 'jquery';
import 'bootstrap';

import * as constants from '../common/constants';
import VanguardConfig from '../../config/vanguard';
import '../assets/scss/vendor.scss';
import '../assets/scss/ogone.scss';
import '../assets/scss/app.scss';
import messages from '../../i18n/messages';
import App from './app';
import ChoiceList from './controllers/choice-list';
import PaymentMethod from './controllers/payment-method';
import Recurrence from './controllers/recurrence';
import Store from './store/store';

/**
 * Error handlers
 */
window.addEventListener('error', (err, url, lineNumber) => {
  console.error('window.onerror catched', err, url, lineNumber);
});

window.addEventListener('unhandledrejection', e => {
  console.error('window.onunhandledrejection catched', e.reason.message, e);
});

$.readyException = error => {
  console.error('jQuery:readyException catched', error);
};

/**
 * I18N
 */
Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: VanguardConfig.locale,
  messages
});

/**
 * Validation
 */
Vue.use(VeeValidate, {
  delay: 200,
  locale: VanguardConfig.locale,
  i18n,
  dictionary: {
    fr: messages.fr.formValidators,
    en: messages.en.formValidators,
    es: messages.es.formValidators,
    it: messages.it.formValidators
  }
});

// LOGGER
const loggerOptions = {
  isEnabled: true,
  logLevel: process.env.NODE_ENV === 'production' ? 'warn' : 'debug',
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: true,
  separator: '|',
  showConsoleColors: true
};

Vue.use(VueLogger, loggerOptions);
Vue.use(VueResource);
Vue.use(VueCookies);
VueCookies.config('1h');
Vue.use(Vuex);

/**
 * Create custom events to let integrators do things after the DOM is really created and ready
 */
(function () {
  if (typeof window.CustomEvent === 'function') {
    return false;
  }

  function CustomEvent(event, params) {
    params = params || {bubbles: false, cancelable: false, detail: null};
    const evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  }

  window.CustomEvent = CustomEvent;
})();

window.App = {
  type: constants.APP_TYPE_MULTIPLE
};

const store = new Vuex.Store(Store);

/**
 * Main app
 */
const VanguardController = new Vue(Object.assign({
  store,
  i18n,
  el: '#root'
}, App));

/**
 * Instanciate the ChoiceListController in order to manage the choice list
 */
const ChoiceListController = new Vue(Object.assign({
  store,
  i18n
}, ChoiceList));

/**
 * Instanciate the PaymentMethodController in order to handle click on specific buttons to change methods
 */
const PaymentMethodController = new Vue(Object.assign({
  store,
  i18n
}, PaymentMethod));

/**
 * Instanciate the RecurrenceController in order to handle click on specific buttons to change recurrence
 */
const RecurrenceController = new Vue(Object.assign({
  store,
  i18n
}, Recurrence));

// Expose controller in global var in development environment
if (process.env.NODE_ENV !== 'production') {
  window.Vanguard = VanguardController;
  window.ChoiceList = ChoiceListController;
  window.PaymentMethod = PaymentMethodController;
  window.Recurrence = RecurrenceController;
}

export default VanguardController;



// WEBPACK FOOTER //
// ./src/multiple/index.js